export const FAMILY_PURCHASE_PATH = "/buy";
export const FAMILY_PURCHASE_RETURN_PATH = "/buy/return";
